import { Bloomreach } from "@fast-simon/common";
export const getBloomreachID = () => {
    var _a, _b, _c;
    if (Bloomreach === null || Bloomreach === void 0 ? void 0 : Bloomreach.getHasBloomreach()) {
        return (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.exponea) === null || _a === void 0 ? void 0 : _a.configuration) === null || _b === void 0 ? void 0 : _b.customer) === null || _c === void 0 ? void 0 : _c.cookie;
    }
    return undefined;
};
//# sourceMappingURL=bloomreach.js.map